import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      border: `1px solid #D2D2D2`,
      borderRadius: 5,
      padding: '0.8rem 1.6rem',
      minHeight: '32rem',
    },
    table: {
      borderCollapse: 'separate',
      borderSpacing: `0 0.8rem`,
    },
    body: {
      '& :first-child td, & :first-child th': {
        backgroundColor: '#F4F4F4',
      },

      '& td, & th': {
        fontSize: '1.2rem',
        fontFamily: theme.typography.body1.fontFamily,
        padding: '0.8rem',
        margin: 0,
        verticalAlign: 'middle',

        borderBlock: '1px solid #F0F0F0',

        '&:first-child': {
          borderLeft: '1px solid #F0F0F0',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
        },

        '&:last-child': {
          borderRight: '1px solid #F0F0F0',
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
        },

        '& span': {
          marginBottom: '2rem',
        },
      },

      '& td': {
        fontWeight: 400,

        '&:nth-child(2):not([colspan])': {
          paddingRight: '2.6rem',
        },
      },

      '& th': {
        paddingLeft: '1.6rem',
        position: 'relative',

        '&::before': {
          content: '"\\2022"',
          position: 'absolute',
          left: 6,
          top: 6,
        },
      },
    },
  }),
)
